"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var token_utilities_1 = require("./token.utilities");
var cookie_service_1 = require("../../cookie-service");
exports.EXCLUDE_AUTH_TOKEN = new core_1.InjectionToken('exclude auth token');
var AuthTokenInterceptor = /** @class */ (function () {
    function AuthTokenInterceptor(cookieService, excludePatterns) {
        this.cookieService = cookieService;
        this.excludePatterns = excludePatterns;
    }
    AuthTokenInterceptor_1 = AuthTokenInterceptor;
    AuthTokenInterceptor.isPropertiesRequest = function (request) {
        return (request.url.endsWith('properties/urls') ||
            request.url.endsWith('json'));
    };
    AuthTokenInterceptor.prototype.intercept = function (request, next) {
        if (request.headers.has('Authorization') ||
            request.url.includes('/resetPassword') ||
            (request.method === 'GET' &&
                (request.url.includes('/language') ||
                    request.url.includes('/message') ||
                    request.url.includes('/pages/shared'))) ||
            AuthTokenInterceptor_1.isPropertiesRequest(request) ||
            this.isExcluded(request)) {
            return next.handle(request);
        }
        if (!token_utilities_1.isProductionMode()) {
            request = request.clone({
                withCredentials: true,
            });
        }
        return next.handle(token_utilities_1.addToken(request, this.cookieService));
    };
    AuthTokenInterceptor.prototype.isExcluded = function (request) {
        if (this.excludePatterns === undefined ||
            this.excludePatterns === null) {
            return false;
        }
        return this.excludePatterns.some(function (pattern) { return pattern.match(request); });
    };
    AuthTokenInterceptor = AuthTokenInterceptor_1 = __decorate([
        core_1.Injectable(),
        __param(1, core_1.Inject(exports.EXCLUDE_AUTH_TOKEN)),
        __param(1, core_1.Optional()),
        __metadata("design:paramtypes", [cookie_service_1.CookieService, Array])
    ], AuthTokenInterceptor);
    return AuthTokenInterceptor;
    var AuthTokenInterceptor_1;
}());
exports.AuthTokenInterceptor = AuthTokenInterceptor;
//# sourceMappingURL=auth-token.interceptor.js.map